import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dateLaterThan',
  standalone: false,
})
export class DateLaterThanPipe implements PipeTransform {
  constructor() {}

  public transform(date: Date, compareDate: Date): boolean {
    return date > compareDate;
  }
}
